import { createRolldownPlugin } from 'unplugin'

import { unpluginFactory } from './unpluginFactory.ts'

export default createRolldownPlugin(unpluginFactory)
